import { NgModule } from '@angular/core';

import { FocusElementDirective } from '@directives/focus-element/focus-element.directive';

@NgModule({
    declarations: [FocusElementDirective],
    exports: [FocusElementDirective],
})
export class FocusElementModule {}
